<template>
  <el-dialog
    :title="dialogtitle"
    :visible.sync="dialogVisible"
    @close="$emit('update:visible',false)"
  >
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <!-- <el-form-item label="跳转路径:" prop="url">
          <el-input v-model="url" placeholder=""></el-input>
        </el-form-item> -->
        <el-form-item label="指定商品:" prop="goods_number">
          <div class="goodsType">
                      <template v-if="goodsList.length>0">
                        <span v-for="item in goodsList" :key="item.id">
                          {{item.goods_name}}
                        </span>                        
                      </template>  
                     <template v-else>
                       {{defaultName}}
                      </template>
            </div>
          <!-- <el-button size="small" @click="gettypeFn(2)">选择商品</el-button>
           -->
           <el-button size="small" @click="dialogGoods = true">选择商品</el-button>
        </el-form-item>
        <!-- <el-form-item label="跳转路径:" prop="sort">
          <el-input type="number" v-model="formdata.sort" :min="0" placeholder="请输入数字排序值(值越小越靠前)"></el-input>
        </el-form-item>         -->
        <!-- <el-form-item label="图片地址">
          <uploadImg @getChildValue="getChildValue" imgNumber="1" page="goodsSpecificationDialog"
                     :picSrc="formdata.pic"></uploadImg>
        </el-form-item> -->
        <!-- <el-form-item label="上级分类:">
          <el-select v-model="formdata.parent_id" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>         -->
        <el-form-item label="上传图片"  prop="pic">
          <el-upload
            class="avatar-uploader"
            :action="uploadurl"
            :show-file-list="false"
            :data="data_"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <div v-if="pic!==''" class="avatar" :style="{ backgroundImage: 'url(' + pic + ')' }" >
              <!-- <img  :src="formdata.pic"  /> -->
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-switch
            v-model="status"
            active-color="#2AA3F8"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <shenhegoodsDialog :visible.sync="dialogGoods" @updatePageInfo="updatePageInfo"></shenhegoodsDialog>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
import uploadImg from "@/components/dialog/uploadImg.vue";
import shenhegoodsDialog from '@/components/tkdialog/shenhegoodsDialog';
export default {
  name: "imgClassifyDialog",
  props: ["visible", "type", "classifyitem"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  components: {
      uploadImg,
      shenhegoodsDialog
    },
  data() {
    var validateSort = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入分类排序值'));
      } else {
        if (value < 0) {
          callback(new Error('值不能小于0'));
        } else {
          callback();
        }  
      }
    };
    return {
      dialogtitle: "新增图片",
      dialogVisible: this.visible,
      data_: {token: sessionStorage.getItem("token")},
      pic:'',
      url:'',
      goods_number:"",
      goods_name:"",
      goods_id: "",
      id: "",
      formdata: {
        id: "",
        cate_id: "",
        name: "",
        parent_id: "",
        pic: "",
        sort: ""
      },
      status:true,
      isnew:[
        {
          value: 0,
          label: "否"
        },
        {
          value: 1,
          label: "是"
        }
      ],
      uploadurl: api.uploadTokenImg,
      options: [],
      defaultName:'',
      goodsList : [],//列表
      dialogGoods: false,
      lock: true,
      rules: {
        url: [{ required: false, message: "请输入跳转链接", trigger: "blur" }],
        pic: [{ required: true,  message: "请上传图片", trigger: 'blur' }]
        // pic: [{ required: true, validator: validateSort, trigger: 'blur' }]
       
      },
      catelogo:""
    };
  },
  created() {
    if (this.type === "edit") {
      console.log(this.classifyitem,'this.classifyitem')
      this.dialogtitle = "编辑图片";
      this.formdata.id = this.classifyitem.id;
      this.url = this.classifyitem.url;
      this.goods_number = this.classifyitem.goods_number;
      this.title = this.classifyitem.goods_name;
      this.pic = this.classifyitem.pic;
      this.formdata.pic = this.classifyitem.pic;
      this.formdata.status = this.classifyitem.status;
      this.status = this.classifyitem.status == 1? true:false
     
    }
    this.queryparentclassify();
    this.InitFn();
  },
  methods: {
    getChildValue(option) {
        console.log('option',option)
        this.formdata.pic = option
    },
    updatePageInfo(option) {
      this.goodsList = option;
     
      let arr = [];
      for (let i = 0; i < option.length; i++) {
        arr.push(option[i].id);
        arr.push(option[i].goods_name);
      }
      // console.log(this.formdata.id)
      // this.formdata.eid = arr.join(',');
      this.goods_number = arr[0];
      this.title = arr[1];
      this.InitFn();
     
      // console.log(arr)
    },
    onChange(e) {
      this.goods_number = e;
    },
    gettypeFn() {
        this.addcheckemployeedialog = !this.addcheckemployeedialog
    },
    // 查询父级分类
    queryparentclassify() {
      let params = {};
      this.axios
        .post(api.goods_cate_parent_list, params)
        .then(response => {
         
          if (response.data.code == 0) {
            this.options = response.data.list || [];
            // this.formdata = response.data.result;
            // console.log(response.data.result.goods_name)
            // this.defaultName = response.data.result.goods_name;
          } else {
          }
        })
        .catch(() => {});
    },
    InitFn() {
      console.log(454)
      console.log(this.goods_number)
      if (this.goods_number) {
          this.axios
              .post(api.goods_detail, {goods_id: this.goods_number})
              .then(response => {
                if (response.data.code == 0) {
                  // this.formdata = response.data.info;
                  this.defaultName = response.data.info.goods_name;
                  console.log(4444)
                  console.log(this.defaultName)
                 
                } else {
                }
              })
              .catch(response => {
              });
            }
      },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.pic = res.path;
        this.formdata.pic = res.path
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isJPG && isLt2M;
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lock) {
            this.lock = false;
            this.submitsave();
            // if (this.type === "edit") {
            //   this.submiteditsave();
            // } else {
            //   this.submitsave();
            // }
          }
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      this.$emit("classifysuccess",{
        pic: this.pic,
        url:this.url,
        status:this.status? 1:0,
        title:this.title,
        goods_number:this.goods_number,
      });
      return
      let params = {
        name: this.formdata.name,
        parent_id: this.formdata.parent_id,
        pic: this.formdata.pic
      };
      this.axios
        .post(api.goods_cate_add, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("classifysuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    },
    // 提交编辑保存
    submiteditsave() {
      let params = {
        cate_id: this.formdata.cate_id,
        name: this.formdata.name,
        sort: this.formdata.sort,
        parent_id: this.formdata.parent_id,
        pic: this.formdata.pic
      };
      this.axios
        .post(api.goods_cate_edit, params)
        .then(response => {
          
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("classifysuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    }
  }
};
</script>
<style scoped>
  .avatar-uploader-icon{
    width: 140px;
    height: 140px;
    line-height: 140px;
  }
  .avatar{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: no-repeat;
    background-size: cover;
    background-position: center;
  }
</style>

